import { render, staticRenderFns } from "./scratchAction.vue?vue&type=template&id=5e2f7e96&scoped=true"
import script from "./scratchAction.vue?vue&type=script&lang=js"
export * from "./scratchAction.vue?vue&type=script&lang=js"
import style0 from "./scratchAction.vue?vue&type=style&index=0&id=5e2f7e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f7e96",
  null
  
)

export default component.exports